module.exports = __webpack_public_path__ + "img/xiaochengxu.e4f88ad7.png";